import { supabase } from '../config/supabaseClient';

export async function fetchProfileByUid(firebaseUid) {
  const { data, error } = await supabase
    .from('profiles')
    .select('*')
    .eq('firebase_uid', firebaseUid)
    .maybeSingle();

  if (error) throw error;
  return data;
}

export async function upsertProfile(profile) {
  const { data, error } = await supabase
    .from('profiles')
    .upsert(
      {
        ...profile,
        updated_at: new Date().toISOString(),
      },
      { onConflict: 'firebase_uid' }
    )
    .select()
    .single();

  if (error) throw error;
  return data;
}

export async function updateProfile(firebaseUid, fields) {
  const { data, error } = await supabase
    .from('profiles')
    .update({
      ...fields,
      updated_at: new Date().toISOString(),
    })
    .eq('firebase_uid', firebaseUid)
    .select()
    .single();

  if (error) throw error;
  return data;
}
